import React, { useState, useEffect } from "react";
import { collection, addDoc, getDocs, query, orderBy, deleteDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext";
export default function Comments({ productId }) {
     const { Toastshow } = Toast();
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState("");
    const userId = Cookies.get("guid"); // Must exist
    const userName = Cookies.get("username") || "Anonymous";
    const photourl = Cookies.get("login_photoURL") || "https://firebasestorage.googleapis.com/v0/b/aoozpayment.firebasestorage.app/o/images_files%2Fphotos_icon.png?alt=media&token=251fe974-e474-43af-9059-9c1779b8a95f";


    // Load comments
    useEffect(() => {
        const loadComments = async () => {
            try {
                const commentsRef = collection(db, "products_comments", productId, "comments");
                const q = query(commentsRef, orderBy("createdAt", "desc"));
                const snapshot = await getDocs(q);
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setComments(data);
            } catch (err) {
                console.error("Error loading comments:", err);
            }
        };

        if (productId) loadComments();
    }, [productId]);

    const handleAddComment = async () => {
        if (!newComment.trim()) return;
        if (!userId) return console.error("User not logged in");

        try {


            
            const commentsRef = collection(db, "products_comments", productId, "comments");
            await addDoc(commentsRef, {
                userId,
                userName,
                photourl,
                text: newComment,
                createdAt: new Date() // Use Firestore server timestamp
            });
            setNewComment("");

            // Reload comments after adding
            const snapshot = await getDocs(query(commentsRef, orderBy("createdAt", "desc")));
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setComments(data);
        } catch (err) {
            console.error("Error adding comment:", err);
        }
    };

    const handleDeleteComment = async (commentId) => {
        try {
            const commentRef = doc(db, "products_comments", productId, "comments", commentId);
            await deleteDoc(commentRef);
            setComments(prev => prev.filter(c => c.id !== commentId));
        } catch (err) {
            console.error("Error deleting comment:", err);
        }
    };

    return (
        <div className="mt-4">
            <div className="text-f2 font-bold mb-2">Comments</div>
            <div className="flex m-1">
                <input
                    type="text"
                    className="border rounded  "
                    value={newComment}
                    placeholder="Add a comment..."
                    maxLength={160}
                    onChange={(e) => setNewComment(e.target.value)}
                />
                <div className="button-ui2 p-11 cursor" onClick={handleAddComment}>
                    Add
                </div>
            </div>

            <div  >
                {comments.map(comment => (
                    <div key={comment.id} className="b-1 m-1 p-11 rounded">

                        <p className="text-2">{comment.text}</p>


                        <table>
                            <tr>

                                <td width={50}>
                                    <img alt="Photo" className="icon_logo rounded-circle" src={comment.photourl || ""}></img>

                                </td>
                                <td>
                                    <table>
                                        <tr>

                                            <td className="text-h2 bold fcap">
                                                {comment.userName}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td>
                                                <a className="text-h4 text-off">
                                                    {comment.createdAt?.toDate ? comment.createdAt.toDate().toLocaleString() : new Date().toLocaleString()}
                                                </a>
                                            </td>
                                        </tr>
                                    </table>

                                </td>
                                <td width={60}>
                                    {comment.userId === userId && (
                                        <div
                                            onClick={() => handleDeleteComment(comment.id)}
                                            className="button-ui1 text-h3 text-off cursor hover-u"
                                        >
                                            Delete
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </table>

                    </div>
                ))}
            </div>
        </div>
    );
}
